<template>
  <layout>

    <sticky-post-menu 
      header="Home settings" 
      @onclick="onSaveClick"/>

    <block-section
      :items="top_categories"
      header="Top categories section"
      @onaddclick="top_categories.push({id: null, image: null})"
      @ontrashclick="top_categories = top_categories.filter(item => item !== $event)">
      <category-block-form 
        slot-scope="{ item }" 
        :item="item"/>
    </block-section>

    <hr>

    <block-section
      :items="home_advantages"
      header="Advantages section"
      @ontrashclick="home_advantages = home_advantages.filter(item => item !== $event)"
      @onaddclick="home_advantages.push({title: '', image: null, description: ''})">
      <advantages-block-form 
        slot-scope="{ item }" 
        :item="item"/>
    </block-section>

    <hr>

    <block-section
      :items="highlighted_categories"
      header="Highlited categories section"
      @onaddclick="highlighted_categories.push({id: null, image: null})"
      @ontrashclick="highlighted_categories = highlighted_categories.filter(item => item !== $event)">
      <category-block-form 
        slot-scope="{ item }" 
        :item="item"/>
    </block-section>

  </layout>
</template>

<script>
import Layout from '../layouts/Default.vue';
import BlockSection from '../components/BlockSection.vue';
import CategoryBlockForm from '../components/CategoryBlockForm.vue';
import AdvantagesBlockForm from '../components/AdvantagesBlockForm.vue';
import StickyPostMenu from '../components/StickyPostMenu.vue';

export default {

  name: 'HomeIndex',

  components: {
    Layout,
    BlockSection,
    CategoryBlockForm,
    AdvantagesBlockForm,
    StickyPostMenu
  },

  data() {
    return {
      top_categories: [],
      home_advantages: [],
      highlighted_categories: []
    }
  },

  created() {
    this.fetchCategories()
      .then(response => {
        window.categories = response.data.data.map(({id, title}) => {
          return {value: id, label: title};
        });
        return this.fetchSettings();
      })
      .catch(error => console.error(error));
  },

  methods: {
    onSaveClick() {
      this.$http.post('/admin-settings/settings', {
        top_categories: this.top_categories,
        home_advantages: this.home_advantages,
        highlighted_categories: this.highlighted_categories
      })
      .then(response => console.log(response.data))
      .catch(err => console.error(err))
    },

    fetchSettings() {
      this.$http.get('/admin-settings/settings', {
        params: {
          keys: [
            'top_categories',
            'highlighted_categories',
            'home_advantages']
          .join(',')
        }
      })
      .then(({ data }) => {
        this.top_categories = data.top_categories || []
        this.highlighted_categories = data.highlighted_categories || []
        this.home_advantages = data.home_advantages || []
      })
      .catch(console.error)
    },

    fetchCategories() {
      return this.$http.get('/categories', {
        params: { per_page: 999 }
      });
    }
  }
}
</script>

<style>
.dropdown-toggle:after {
  display: none;
}

.img-inputer {
  width: 100% !important;
}

.save-button {
  position: fixed;
  bottom: 60px;
  right: 60px;
}
</style>
